module.exports = __webpack_public_path__ + "img/1f68ffbf5890f92c2f5b063ddb060c60.png";